module.exports = __webpack_public_path__ + "img/noData.57b830ab.svg";